export default __webpack_public_path__ + "static/media/P102 zu P104.b5626e23.mp3";